/* eslint-disable max-lines */
import PropTypes from "prop-types";
import React from "react";

export default class StateField extends React.Component {
  stateList = () => [
    {
      "abbreviation": "AK",
      "name": "Alaska"
    },
    {
      "abbreviation": "AL",
      "name": "Alabama"
    },
    {
      "abbreviation": "AR",
      "name": "Arkansas"
    },
    {
      "abbreviation": "AS",
      "name": "American Samoa"
    },
    {
      "abbreviation": "AZ",
      "name": "Arizona"
    },
    {
      "abbreviation": "CA",
      "name": "California"
    },
    {
      "abbreviation": "CO",
      "name": "Colorado"
    },
    {
      "abbreviation": "CT",
      "name": "Connecticut"
    },
    {
      "abbreviation": "DC",
      "name": "District Of Columbia"
    },
    {
      "abbreviation": "DE",
      "name": "Delaware"
    },
    {
      "abbreviation": "FL",
      "name": "Florida"
    },
    {
      "abbreviation": "FM",
      "name": "Federated States Of Micronesia"
    },
    {
      "abbreviation": "GA",
      "name": "Georgia"
    },
    {
      "abbreviation": "GU",
      "name": "Guam"
    },
    {
      "abbreviation": "HI",
      "name": "Hawaii"
    },
    {
      "abbreviation": "IA",
      "name": "Iowa"
    },
    {
      "abbreviation": "ID",
      "name": "Idaho"
    },
    {
      "abbreviation": "IL",
      "name": "Illinois"
    },
    {
      "abbreviation": "IN",
      "name": "Indiana"
    },
    {
      "abbreviation": "KS",
      "name": "Kansas"
    },
    {
      "abbreviation": "KY",
      "name": "Kentucky"
    },
    {
      "abbreviation": "LA",
      "name": "Louisiana"
    },
    {
      "abbreviation": "MA",
      "name": "Massachusetts"
    },
    {
      "abbreviation": "MD",
      "name": "Maryland"
    },
    {
      "abbreviation": "ME",
      "name": "Maine"
    },
    {
      "abbreviation": "MH",
      "name": "Marshall Islands"
    },
    {
      "abbreviation": "MI",
      "name": "Michigan"
    },
    {
      "abbreviation": "MN",
      "name": "Minnesota"
    },
    {
      "abbreviation": "MO",
      "name": "Missouri"
    },
    {
      "abbreviation": "MP",
      "name": "Northern Mariana Islands"
    },
    {
      "abbreviation": "MS",
      "name": "Mississippi"
    },
    {
      "abbreviation": "MT",
      "name": "Montana"
    },
    {
      "abbreviation": "NC",
      "name": "North Carolina"
    },
    {
      "abbreviation": "ND",
      "name": "North Dakota"
    },
    {
      "abbreviation": "NE",
      "name": "Nebraska"
    },
    {
      "abbreviation": "NH",
      "name": "New Hampshire"
    },
    {
      "abbreviation": "NJ",
      "name": "New Jersey"
    },
    {
      "abbreviation": "NM",
      "name": "New Mexico"
    },
    {
      "abbreviation": "NV",
      "name": "Nevada"
    },
    {
      "abbreviation": "NY",
      "name": "New York"
    },
    {
      "abbreviation": "OH",
      "name": "Ohio"
    },
    {
      "abbreviation": "OK",
      "name": "Oklahoma"
    },
    {
      "abbreviation": "OR",
      "name": "Oregon"
    },
    {
      "abbreviation": "PA",
      "name": "Pennsylvania"
    },
    {
      "abbreviation": "PR",
      "name": "Puerto Rico"
    },
    {
      "abbreviation": "PW",
      "name": "Palau"
    },
    {
      "abbreviation": "RI",
      "name": "Rhode Island"
    },
    {
      "abbreviation": "SC",
      "name": "South Carolina"
    },
    {
      "abbreviation": "SD",
      "name": "South Dakota"
    },
    {
      "abbreviation": "TN",
      "name": "Tennessee"
    },
    {
      "abbreviation": "TX",
      "name": "Texas"
    },
    {
      "abbreviation": "UT",
      "name": "Utah"
    },
    {
      "abbreviation": "VA",
      "name": "Virginia"
    },
    {
      "abbreviation": "VI",
      "name": "Virgin Islands"
    },
    {
      "abbreviation": "VT",
      "name": "Vermont"
    },
    {
      "abbreviation": "WA",
      "name": "Washington"
    },
    {
      "abbreviation": "WI",
      "name": "Wisconsin"
    },
    {
      "abbreviation": "WV",
      "name": "West Virginia"
    },
    {
      "abbreviation": "WY",
      "name": "Wyoming"
    }
  ];

  renderStates = () => this.stateList().map(state => this.getStateAbr(state));

  getStateAbr = stateObj => (
    <option
      key={stateObj.abbreviation}
      value={stateObj.abbreviation}
    >
      {stateObj.abbreviation}
    </option>
  );

  render () {
    const {label, labelAdditionalClassName, selectClassName, state, changeHandler, selectId} = this.props;

    return (
      <React.Fragment>
        <label className={`state ${labelAdditionalClassName}`}>
          {label}
        </label>
        <select
          aria-label="state"
          className={selectClassName}
          id={selectId || "state"}
          name="state"
          onChange={changeHandler}
          style={{
            "MozAppearance": "none",
            "WebkitAppearance": "none",
            "appearance": "none",
            "background": "url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+) no-repeat 95% 50%", // eslint-disable-line max-len
            "color": !state && "gray"
          }}
          value={state}
        >
          <option
            defaultValue
            disabled
            hidden
            value=""
          >
            Select
          </option>
          { this.renderStates() }
        </select>
      </React.Fragment>
    );
  }
}

StateField.propTypes = {
  "changeHandler": PropTypes.func.isRequired,
  "label": PropTypes.string,
  "labelAdditionalClassName": PropTypes.string,
  "selectClassName": PropTypes.string,
  "selectId": PropTypes.string,
  "state": PropTypes.string
};

StateField.defaultProps = {
  "label": "State*",
  "labelAdditionalClassName": "state",
  "selectClassName": "state-field",
  "selectId": "state",
  "state": ""
};
